import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  ActionIcon,
  Avatar,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Flex,
  Grid,
  Group,
  Loader, 
  Notification, 
  Progress,
  Stack,
  Tabs,
  Text,
  Title,
  UnstyledButton,
} from "@mantine/core";
import { IconAlertCircle, IconCheck, IconHeart, IconHeartFilled, IconShare, IconX } from "@tabler/icons-react";
import { useDisclosure, useMediaQuery, useToggle } from "@mantine/hooks";
import { BackButton, DonationDrawer, NotFound, ShareModal, UserCard } from "../components";
import { Helmet } from "react-helmet-async";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import { notifications } from "@mantine/notifications";
import { convertCurrency, isErrorObject, toTitleCase } from "../utils/utils";
import { makeGetRequest, makePostRequest, makePutRequest } from "../services/httpHelper";
import ErrorHandler from "../services/ErrorHandler";
import { formatCurrency } from "../utils/FormValidator";
import { Link } from "react-router-dom";
//import CampaignDonorsTable from "../components/CampaignDonorsTable";
//import { IMAGE_BASE_URL } from "../services/paths";
import ErrorBoundary from "../utils/ErrorBoundary";
import ManageTeamPage from "./ManageTeams";
import ManageAdminPage from "./ManageAdmins";
import { ICampaign,  ICampaignAdmin,  ICampaignTeam,  ICampaignTransHistory,  ICurrencyRates,  IDonation, IWithdrawal } from "../types";
import { Modal, Select, /*Switch*/ } from "@mantine/core";
import EditCampaignForm from "../components/EditCampaignForm"; // Make sure to create this component
//import NotificationComponent from "../components/Notification";
import TransactionHistory from "./TransactionHistory";
import AdminCampaignDonationTable from "../components/AdminCampaignDonationTable";
import { PayPalButton } from "../components/PaypalButton";
import ManageCampaignPaymentMethods from "./ManageCampaignPaymentMethods";
import { PayPalButtonCancel } from "../components/PaypalButtonCancel";
import CampaignWithdrawalStatement from "../components/CampaignWithdrawalStatement";


interface PaymentMethodData {
  paypal_email?: string; // Use optional property in case it's not always available
  start_paypal_onboarding?: boolean;
  // Add other properties if needed
}

const ManageCampaignPage = (): JSX.Element => {

  dayjs.extend(LocalizedFormat);
  const { id } = useParams();
  const [campaign, setCampaign] = useState<ICampaign>();
  const [opened, { open, close }] = useDisclosure(false);
  const [donateOpened, { open: donateOpen, close: donateClose }] = useDisclosure(false);
  const [following, setFollowing] = useToggle();
  const matchesMobile = useMediaQuery("(max-width: 768px)");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [showPaypalSetupButton,setShowPaypalSetupButton]=useState(false)
  const [transHistory, setTransHistory] = useState<ICampaignTransHistory[]>([]);
  const [teams, setTeams] = useState<ICampaignTeam[]>([]);
  const [admins, setAdmins] = useState<ICampaignAdmin[]>([]);
  const [donations, setDonations] = useState<IDonation[]>([]);
  const [showNotification, setShowNotification] = useState(showPaypalSetupButton);
  const [paymentMethodData, setPaymentMethodData] = useState<PaymentMethodData | null>(null);
  const [exchangeRates, setExchangeRates] = useState<ICurrencyRates>();
    const [campaignWithdrawals,setCampaignWithdrawals]=useState<IWithdrawal[]>([]);
  
  




  //const [totalFollowers, setTotalFollowers] = useState(0);
  //const [teams, setTeams] = useState<ICampaignTeam[]>([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  //const campaignImage = IMAGE_BASE_URL + campaign?.image;
  const user = JSON.parse(localStorage.getItem('user') || '{}');


  //declare navigator
  const navigate = useNavigate();

  const getProgress = (raised: number, target: number): number => {
    return (raised / target) * 100;
  };

  // Currency conversion handler
              const handleCurrencyConversion = (amount: number, fromCurrency: string, toCurrency: string) => {
                  return convertCurrency(amount, fromCurrency, toCurrency, exchangeRates?.rates || {});
              };

  const totalRaised = (): number => {
    let total = 0;
    const campaignDonations = donations && donations.filter((donation) => donation.campaign_id === id);
    campaignDonations?.forEach((d) => {

      if(campaign?.currency === d.donation_currency){
        //proceed in local currency
        total += parseFloat(d.donation_amount);
    }else{
        //calculate total raised amount in USD for global display
        const amountInUsd = handleCurrencyConversion(parseFloat(d.donation_amount),d.donation_currency||'',campaign?.currency||'')

        total += amountInUsd?.amount||0;
    }

    });
    return total;
  };

   // Handle functions for actionable settings
   const handleWithdrawalMandateToggle = async (value: string) => {
    setIsSuccess(false);
    setError(null)
    const confirm = window.confirm('Are sure you want to change withdrawal from campaign approval mandate?')
    if(confirm){
      try {
       const res= await makePutRequest(`campaign/${id}/update-signing-mandate`, { mandate: value });
        if (isErrorObject(res)) {
          const errorMessage = ErrorHandler(res);
          setError(errorMessage);
        } else {
          setIsSuccess(true);                  
        
     
    
        }
      } catch (err) {
        console.error("Failed to update status:", err);
      }

    }
 
  };
  const handleCampaignModeChange = async (value: string) => {
    setIsSuccess(false);
    setError(null)
    let confirmMessage;
  
    switch(value){
      case 'closed':
        confirmMessage='Are sure you want to close this campaign? Closed campaigns will not be visible to donors or accept donations';
      
        break;
        case 'suspended':
          confirmMessage='Are sure you want to mark this campaign as suspended? Once suspended will be available to donors but no donations can be accepted';
          break;
          case 'completed':
            confirmMessage="Are sure you want to mark this campaign as completed? Completed campaigns are thos that have reached its target or is no longer relevant."
            break;
            default:
              confirmMessage="Are sure about this?"
              break;

    }
    const confirm = window.confirm(confirmMessage)

    if(confirm){
          // Send request to update campaign mode
    try {
    const res =  await makePutRequest(`campaign/${id}/update-status`, { status: value });
    if (isErrorObject(res)) {
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
    } else {
      setIsSuccess(true);          
    
 

    }
      
    } catch (err) {
      console.error("Failed to update mode:", err);
    }

    }
  

  };
  const fetchAdmins = async () => {
    const res = await makeGetRequest(`campaign-admins/${id}`);
    setIsLoading(false);
    if (isErrorObject(res)) {
        const errorMessage = ErrorHandler(res);
        setError(errorMessage);
    } else {
        setAdmins(res.data);
    }
};

  const fetchPromoters = async () => {
    const res = await makeGetRequest(`teams/${id}`);
    setIsLoading(false);
    if (isErrorObject(res)) {
        const errorMessage = ErrorHandler(res);
        setError(errorMessage);
    } else {
        setTeams(res.data);
    }
};

  //Fetch data from API
  const fetchCampaignData = async () => {
    setIsLoading(true);
    try {
      const campaignRes = await makeGetRequest(`campaign/${id}`);
      if (isErrorObject(campaignRes)) {
        throw new Error(ErrorHandler(campaignRes));
      }
      setCampaign(campaignRes.data);
     // setTotalFollowers(campaignRes.data.campaignfollowers.length);

      const donationsRes = await makeGetRequest(`campaign-donors/${id}`);
      if (isErrorObject(donationsRes)) {
        throw new Error(ErrorHandler(donationsRes));
      }
      setDonations(donationsRes.data);

      const teamsRes = await makeGetRequest(`campaign-team/${id}`);
      if (isErrorObject(teamsRes)) {
        throw new Error(ErrorHandler(teamsRes));
      }
    } catch (err) {
        console.log(err)
      setError('something went wrong!')
    } finally {
      setIsLoading(false);
    }
  };

  const getTransHistory = async () => {
    setIsLoading(true);
    const res = await makeGetRequest(`campaign/transaction-history/${id}`);

    if (isErrorObject(res)) {
        setIsLoading(false);
        const errorMessage = ErrorHandler(res);
        setError(errorMessage);
    } else {
        const results = res.data;
        setTransHistory(results);       
        setIsLoading(false);
        setError(null);
    }
};


const fetchCampaignWithdrawals = async () => {
  setIsLoading(true);
  const endpoint = `campaign-withdrawals/${id}`;
  const res = await makeGetRequest(endpoint);
  if (isErrorObject(res)) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
  } else {
      setCampaignWithdrawals(res.data);
  }
  setIsLoading(false);
};

const hasPaypalPaymentMethod = async () => {
  setIsLoading(true);
  const res = await makeGetRequest(`check_merchant_paypal_account_setup/${user.id}/${id}`);

  if (isErrorObject(res)) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
  } else {
      const results = res.data;
      console.log(results)
      setPaymentMethodData(results)

      if(results.start_paypal_onboarding){
        setShowPaypalSetupButton(true)
        //setPaypalEmail(results.paypalEmail)
      }
      setIsLoading(false);
      setError(null);
  }
};

const initiatePaypalOnBoarding =async()=>{
  setIsLoading(true);
  const res = await makePostRequest(`generate-paypal-signup-link`,{tracking_id:user.id,email:paymentMethodData?.paypal_email});

  if (isErrorObject(res)) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      console.log(errorMessage)
      setError(errorMessage);
  } else {
    window.location.href = res.data;
      setIsLoading(false);
      setError(null);
  }

}

const unlinkPaypalAccount =async()=>{
  const confirmed = window.confirm("Whenx you Unlink PayPal from your campaign, you will no longer receive donations from PayPal users. You can still relink it at any time. Are sure about this?");
if(confirmed){
  setIsLoading(true);
  const res = await makePostRequest(`unlink-paypal-account`,{tracking_id:user.id,email:paymentMethodData?.paypal_email,campaign_id:campaign?.id});

  if (isErrorObject(res)) {
      setIsLoading(false);
      const errorMessage = ErrorHandler(res);
      console.log(errorMessage)
      setError(errorMessage);
      alert(errorMessage)
  } else {
    alert('PayPal Account Successfully unlinked and new donors will not be able to donate to this campaign from their PayPal Account.')
      setIsLoading(false);
      setError(null);
     
  }
}

}

const followCampaign = async () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const data = {
      user_id: user.id,
      campaign_id: id,
    };
    const res = await makePostRequest("follow-campaign", data);

    if (res && res.errorType) {
      setError(res.errorMessage);
    } else {
      setFollowing(!following);
      notifications.show({
        title: "Notification",
        message: `${following ? "Following" : "Unfollowed"} this campaign`,
        withBorder: true,
      });
    }
  };

  //Access checks - Check for permissions
const isOwner = ()=>{
  var user_is_owners =false;
  if(user.id===campaign?.user_id){
    user_is_owners = true
  }
  return user_is_owners;
}
const isAdmin =()=>{
  var user_is_admin =false
  const inAdmins = admins.filter((admin)=>admin.user.id===user.id);
  if(inAdmins.length){
    user_is_admin = true
  }
 

  return user_is_admin;

  
}
const isTeamMember =()=>{
  var is_team_member = false
  if (teams.length) {
    const isPromoter = teams.some((team) => team.user.id === user.id);
    if (isPromoter) {
      is_team_member = true;
      
  }
  return is_team_member;
  }
}


  const userHasAccess = () => {

    if(isAdmin() || isOwner()||isTeamMember()){
      return true
    }else{
      return false;
    }
  
     
    
   
  
   
  };

   // Fetch exchange rates
      const fetchExchangeRates = async () => {
          const endpoint = "latest-currency-exchange-rates";
          const res = await makeGetRequest(endpoint);
          if (isErrorObject(res)) {
              const errorMessage = ErrorHandler(res);
              setError(errorMessage);
          } else {
              setExchangeRates(res.data);
          }
      };



useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);
      await fetchCampaignData();
      await fetchAdmins();
      await fetchPromoters();
      await getTransHistory();
      await hasPaypalPaymentMethod();
      await fetchExchangeRates();
       await fetchCampaignWithdrawals();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
 

 
}, [id,navigate]);


useEffect(() => {
  if (!isLoading && campaign) {
   
    if (campaign) {
      if(!userHasAccess()){
        navigate('/unauthorized')
    
      }
  }
 
  }

  if (showNotification) {
    const timer = setTimeout(() => setShowNotification(false), 10000); // Auto-hide after 10 seconds
    return () => clearTimeout(timer);
  }
}, [id,navigate,showNotification]);



  return (
    <>
      <ErrorBoundary>
      <Helmet>
      <title>{campaign?.title}</title>
    </Helmet>
        {isLoading && <Loader />}
        {error && <Notification color="red">{error}</Notification>}

        <Box>
        <Container>
        {isLoading && <Loader />}
        {isSuccess && (
    <Notification icon={<IconCheck size={18} />} color="green" mb="lg">
        Status updated
    </Notification>
)}
  {error && (
    <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">
        {error}
    </Notification>
  )}

        </Container>

        {campaign ? (
            <Container size="lg">
              <BackButton mb="md" />
              <Grid>
                <Grid.Col lg={12}>
                  <Stack>
                    <Tabs defaultValue="campaign">
                    <Tabs.List>
                        <Tabs.Tab value="campaign">Campaign</Tabs.Tab>
                        <Tabs.Tab value="donations">Donations</Tabs.Tab>
                        <Tabs.Tab value="promoters">Promoters</Tabs.Tab>
                        <Tabs.Tab value="followers">Followers</Tabs.Tab>
                        <Tabs.Tab value="admins">Admins</Tabs.Tab>
                        <Tabs.Tab value="payment methods">Payment Methods</Tabs.Tab>
                       
                        <Tabs.Tab value="withdrawal">
                          Withdrawal
                        </Tabs.Tab>
                        <Tabs.Tab value="trans-history" >
                          Trans. History
                        </Tabs.Tab>
                      </Tabs.List>

                      <Tabs.Panel value="campaign">
                      <Card padding="md" shadow="sm">
                      <Card.Section>
                            <img crossOrigin="anonymous" src={`${campaign.image}`} height={480} />
                          </Card.Section>
                          <Stack mt="md">
                          {!matchesMobile ? (
                              <Flex gap="xs" align="center">
                                <Text size="sm">Campaign created by</Text>
                                <UnstyledButton component={Link} to={`/user/${campaign.fundRaiser.id}`}>
                                  <Flex gap="xs" align="center">
                                    <Avatar src={campaign?.fundRaiser.avatar} radius="xl" size="sm" />
                                    <Text size="sm">
                                      {campaign?.fundRaiser.first_name} {campaign?.fundRaiser.last_name}
                                    </Text>
                                  </Flex>
                                </UnstyledButton>
                                <Text component={Link} to={`/country/${campaign?.country}`} size="sm">
                                  {campaign?.country}
                                </Text>
                                <Text component={Link} to={`/category/${campaign.category.id}`} size="sm">
                                  {toTitleCase(campaign.category.category)}
                                </Text>
                              </Flex>
                            ) : (
                              <Stack>
                                <Flex gap="md">
                                  <Text size="sm">Fundraise campaign created by</Text>
                                  <UnstyledButton component={Link} to={`/user/${campaign.fundRaiser.id}`}>
                                    <Flex gap="xs" align="center">
                                      <Avatar src={campaign.fundRaiser?.avatar} radius="xl" size="sm" />
                                      <Text size="sm">
                                        {campaign?.fundRaiser.first_name} {campaign?.fundRaiser.last_name}
                                      </Text>
                                    </Flex>
                                  </UnstyledButton>
                                </Flex>
                                <Group>
                                  <Text size="sm">
                                    Location - <Link to={`/country/${campaign?.country}`}>{toTitleCase(campaign?.country)}</Link>
                                  </Text>
                                  <Text size="sm">
                                    Category - <Link to={`/category/${campaign.category.id}`}>{toTitleCase(campaign.category.category)}</Link>
                                  </Text>
                                </Group>
                              </Stack>
                            )}
                             <Text size="lg" weight={600}>
                              Our story
                            </Text>
                            <Text size="sm">{campaign?.description}</Text>
                            <Divider />
                            <Flex justify="space-between">
                              <Title size={32}>{campaign.currency}{formatCurrency(totalRaised())}</Title>
                              <Text fw={500} align="center" color="dimmed">
                                raised of {formatCurrency(parseFloat(campaign?.target.toString()))}
                              </Text>
                            </Flex>
                            <Progress value={getProgress(parseFloat(totalRaised().toString()), parseFloat(campaign.target.toString()))} size="md" />
                           
                            
                            {(isOwner() || isAdmin()) && (
      <Flex justify="space-between" direction={{ base: 'column', sm: 'row' }}
      align="center">
        <Text fw={500}>{donations.length} Donors</Text>
        <Button onClick={() => setEditModalOpen(true)}>Edit Campaign</Button>
        <Button onClick={() => navigate(`/dashboard/campaign/manage/add-bank/${campaign.id}`)}>Add Bank</Button>
      </Flex>
    )}

    {showPaypalSetupButton ? (
      <>
        <Flex justify="space-between" mt="md" direction={{ base: 'column', sm: 'row' }}
            align="center">
          <Text fw={500}>Link PayPal Account</Text>
          {/*<Button onClick={() => initiatePaypalOnBoarding()}>Link PayPal Account</Button>*/}
          <PayPalButton onClick={() => initiatePaypalOnBoarding()}/>
        </Flex>

        {showNotification && (
          <Notification
            title="Enable PayPal Donations"
            color="blue"
            onClose={() => setShowNotification(false)}
            icon={<IconX />}
            style={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 350,
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            Your campaign includes PayPal as a donation method. To receive donations via PayPal, 
            you need to onboard by creating or verifying your PayPal account. Without completing this process, 
            you may miss out on donations from PayPal users.
            <Flex mt="sm" justify="flex-end">
              <Button size="xs" onClick={() => initiatePaypalOnBoarding()}>
                Setup PayPal Now
              </Button>
            </Flex>
          </Notification>
        )}
      </>
    )
    :
    (
      <>
        <Flex justify="space-between" mt="md">
          <Text fw={500}>Unlink PayPal Account</Text>
          {/*<Button onClick={() => initiatePaypalOnBoarding()}>Link PayPal Account</Button>*/}
          <PayPalButtonCancel onClick={() => unlinkPaypalAccount()}/>
        </Flex>

        {showNotification && (
          <Notification
            title="Enable PayPal Donations"
            color="blue"
            onClose={() => setShowNotification(false)}
            icon={<IconX />}
            style={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 350,
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          >
          When you Unlink PayPal from your campaign, you will no longer receive donations from PayPal users. You can still relink it at any time.
            <Flex mt="sm" justify="flex-end">
              <Button size="xs" onClick={() => unlinkPaypalAccount()}>
                Unlink PayPal
              </Button>
            </Flex>
          </Notification>
        )}
      </>
    )
    }
  
                           <Flex align="center" gap="xs">
                              <Button onClick={donateOpen} fullWidth>
                                Donate
                              </Button>
                              <ActionIcon
                                variant="subtle"
                                onClick={open}
                                color="blue"
                                title="Share with your friends"
                                size="lg"
                              >
                                <IconShare size={18} />
                              </ActionIcon>
                              <ActionIcon
                                title={`${following ? "Unfollow" : "Follow"} this campaign`}
                                size="lg"
                                color="secondary"
                                onClick={followCampaign}
                              >
                                {following ? <IconHeartFilled size={18} /> : <IconHeart size={18} />}
                              </ActionIcon>
                            </Flex>
                          </Stack>
                           {/* Actionable Settings */}
                           <Stack mt="md" spacing="xs">
                           <Group position="apart">
                        <Text>Campaign Mode</Text>
                        <Select
                          data={[
                            { value: "active", label: "Active" },
                            { value: "closed", label: "Closed" },
                            { value: "suspended", label: "Suspended" },
                            { value: "completed", label: "Completed" },
                          ]}
                          value={campaign.compaign_type}
                          placeholder={campaign.status.toLocaleUpperCase()}
                          onChange={handleCampaignModeChange}
                        />
                      </Group>
                      <Group position="apart">
                        <Text>Withdrawal Mandate</Text>
                        <Select
                          data={[
                            { value: "any_two", label: "Any Two" },
                            { value: "all", label: "All" },
                          ]}
                          value={campaign.withdrawal_mandate}
                          disabled={!campaign.has_admins}
                          placeholder={campaign.withdrawal_mandate}
                          onChange={handleWithdrawalMandateToggle}
                        />
                      </Group>
                           </Stack>
                      </Card>
                      </Tabs.Panel>

                      <Tabs.Panel value="donations">
                        <AdminCampaignDonationTable donations={donations} campaign_currency={campaign?.currency} Withdrawals={campaignWithdrawals}/>
                      </Tabs.Panel>
                      <Tabs.Panel value="promoters">
                        <ManageTeamPage campaign={campaign}/>
                      </Tabs.Panel>
                      <Tabs.Panel value="followers">
                        <UserCard campaignId={id ?? ''}/>
                      </Tabs.Panel>
                      <Tabs.Panel value="admins">
                        <ManageAdminPage />
                      </Tabs.Panel>

                      <Tabs.Panel value="payment methods">
                        <ManageCampaignPaymentMethods campaignId={campaign.id}/>
                      </Tabs.Panel>
                       <Tabs.Panel value="withdrawal">
                        <br/>
                        <Link to={`/initiate-withdrawal/${id}`}>Initiate Withdrawal</Link>
                        <br/>
                        <CampaignWithdrawalStatement withdrawals={campaignWithdrawals} campaign_currency={campaign.currency}/>
                      </Tabs.Panel>

                      <Tabs.Panel value="trans-history">
                        <TransactionHistory transactions={transHistory} campaignId={id||''} campaign_currency={campaign.currency}/>
                      </Tabs.Panel>

                    </Tabs>
                  </Stack>
                </Grid.Col>
               
              </Grid>
               {/* Edit Campaign Modal */}
            <Modal
              opened={editModalOpen}
              onClose={() => setEditModalOpen(false)}
              title="Edit Campaign"
            >
              <EditCampaignForm
                campaign={campaign}
                onClose={() => setEditModalOpen(false)}
                onSave={(updatedCampaign) => setCampaign(updatedCampaign)}
              />
            </Modal>
            </Container>
          ) : (
            <NotFound />
          )}

<ShareModal opened={opened} onClose={close} campaign={campaign} iconSize={18}/>
<DonationDrawer campaign={campaign} opened={donateOpened} onClose={donateClose} iconSize={18}/>
          
        </Box>
    


      </ErrorBoundary>
    </>
  );
}

export default ManageCampaignPage;





    
  


